import tw, { styled } from "twin.macro";

export const SplitItems = styled.div`
  ${tw`flex flex-col gap-[70px] lg:gap-[60px]`}
`;

export const SplitItem = styled.div`
  ${tw`flex flex-col items-center gap-[25px]`}
  ${tw`lg:flex-row lg:flex-nowrap lg:gap-[60px]`}
`;

export const SplitContent = styled.div`
  ${tw`text-center`}
  ${tw`lg:text-left lg:basis-[56%] lg:flex-grow-0`}

  p:last-of-type {
    ${tw`mb-0`}
  }
`;

export const SplitImage = styled.div<{ even?: boolean }>`
  ${tw`max-w-[370px] -order-1 lg:order-1`}
  ${tw`lg:max-w-none lg:flex-grow lg:flex lg:flex-col lg:items-center`}

  ${(props) => (props.even ? tw`lg:-order-1` : "")}
`;

export const SplitHeadlineBlack = styled.h4`
  ${tw`text-title font-title font-medium self-stretch md:mt-0`}

  font-size: 24px;
  line-height: 32px;

  a {
    ${tw`text-theme-blue-1`}
  }
`;

export const SplitHeadlineWhite = styled.h4`
  ${tw`text-white font-title font-medium self-stretch md:mt-0`}

  font-size: 24px;
  line-height: 32px;

  a {
    ${tw`text-theme-blue-1`}
  }
`;

export const SplitDescription = styled.div`
  ${tw`text-theme-gray-7 font-subtitle font-normal self-stretch`}

  font-size: 21px;
  line-height: 32px;

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 32px;
  }

  a {
    ${tw`text-theme-gray-7 underline`}

    &:hover {
      ${tw`text-theme-blue-1`}
    }
  }
`;

export const SplitDescriptionWhite = styled.div`
  ${tw`text-white font-subtitle font-normal self-stretch`}

  font-size: 21px;
  line-height: 32px;

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 32px;
  }

  a {
    ${tw`text-white underline`}

    &:hover {
      ${tw`text-theme-blue-1`}
    }
  }
`;
